import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { PageSettings } from '../../config/page-settings.js';
import withNotification from '../../components/HOCNotification/HOCNotification.component';
import InputMask from 'react-input-mask';

import UserProfile from '../../services/userProfile.js';
import { COPYRIGHT, RESPONSE } from '../../config/constants';
import Services from '../../services/service';

const userProfile = new UserProfile();
const { SUCCESS, FAILED } = RESPONSE;

class ChangePassword extends React.Component {
	static contextType = PageSettings;

	constructor(props) {
		super(props);

        const username = userProfile.getUsername();
		if(!username){
			this.props.history.push('/login')
		}

		this.state = {
			username: username,
			password: '',
            confirmPassword: '',
            passwordNotMatch: false,
            securityCode: '',
			captchaVerify: '',
			captchaCode: '',
			formErrors: [],
			submitLoading: false
		}
		this.handleSubmit = this.handleSubmit.bind(this);
	}
  
	componentDidMount() {
		this.context.handleSetPageSidebar(false);
		this.context.handleSetPageHeader(false);
		this.context.handleSetBodyWhiteBg(true);
	}

	componentWillUnmount() {
		this.context.handleSetPageSidebar(true);
		this.context.handleSetPageHeader(true);
		this.context.handleSetBodyWhiteBg(false);
	}

	handleFieldChange = (key) => (e) => {
		const state = { [key]: e.target.value };
		this.setState(state);
	}
	
	handleSubmit(e) {
		e.preventDefault();
		let validate = this.validateForm()
		if(validate){
			this.postLogin();
		}
	}

	validateForm() {
		let errors  = [];
		if(this.state.password === '') {
			errors.push('password')
		}
		if(this.state.confirmPassword === '') {
			errors.push('confirmPassword');
		}
		if(this.state.securityCode === '') {
			errors.push('securityCode');
		}
        if(this.state.password !== this.state.confirmPassword){
            errors.push('password');
            errors.push('confirmPassword');
            this.setState({ passwordNotMatch: true });
        }

		this.setState({
			formErrors: errors
		});

		if(errors.length > 0){
			return false;
		}else{
			return true;
		}
	}

	hasError(key) {
		return this.state.formErrors.indexOf(key) !== -1;
	}

	postLogin = async() => {
		const { username, password, securityCode } = this.state;
        const unmaskSecurityCode = securityCode.replace(/[-_]/g, '');
		const payload = { username, securityCode: unmaskSecurityCode, newPassword: password };

		this.setState({ submitLoading: true });

		await Services.postVerifyPassword(payload)
			.then(res => {
				console.log(res);
				this.props.toggleNotification(SUCCESS);
                this.setState({ submitLoading: false });
                setTimeout(this.props.history.push('/login'), 3000);
			})
			.catch(err => {
                const parseErr = JSON.parse(err.request.response);
				this.props.toggleNotification(FAILED, parseErr.error);
                this.setState({ submitLoading: false });
				return;
			})
	}
  
	render() {
		const { 
            password, 
            confirmPassword, 
            securityCode, 
            submitLoading,
            passwordNotMatch
        } = this.state;
		return (
			<div className="login login-with-news-feed">
				<div className="news-feed">
					<div className="news-image" style={{backgroundImage: 'url(/assets/img/login-bg/login-image.jpg)'}}></div>
					<div className="news-caption">
					</div>
				</div>
				<div className="right-content">
					<div className="login-header">
						<div className="brand">
                            <h1>Ubah Password</h1>
						</div>
						<div className="icon">
							<i className="fa fa-sign-in"></i>
						</div>
					</div>
					<div className="login-content">
                        <div className="note note-warning note-with-end-icon">
                            <div className="note-icon"><i className="fa fa-lightbulb"></i></div>
                            <div className="note-content text-end">
                                <h4><b>Kode OTP sudah terkirim!</b></h4>
                                <h5>Silahkan cek inbox email Anda.</h5>
                            </div>
                        </div>
                        <form className="margin-bottom-0" onSubmit={this.handleSubmit}>
                            <div className="form-group m-b-15">
                                <input type="password" className={`form-control form-control-lg ${this.hasError("password") ? 'is-invalid': ''}`} placeholder="Password Baru" 
                                id="password" name="password" onChange={this.handleFieldChange('password')}
                                value={password}/>
                                <div className="invalid-feedback">{(passwordNotMatch) ? 'Password tidak cocok' : 'Password wajib diisi.'}</div>
                            </div>
                            <div className="form-group m-b-15">
                                <input type="password" className={`form-control form-control-lg ${this.hasError("confirmPassword") ? 'is-invalid': ''}`} placeholder="Konfirmasi Password Baru" 
                                id="confirmPassword" name="confirmPassword" onChange={this.handleFieldChange('confirmPassword')}
                                value={confirmPassword}/>
                                <div className="invalid-feedback">{(passwordNotMatch) ? 'Password tidak cocok' : 'Konfirmasi Password wajib diisi.'}</div>
                            </div>
                            <div className="form-group m-b-15">
                                <InputMask mask="9-9-9-9-9-9" className={`form-control form-control-lg ${this.hasError("securityCode") ? 'is-invalid': ''}`} 
                                placeholder="Kode OTP" id="securityCode" name="securityCode"
                                value={securityCode} onChange={this.handleFieldChange('securityCode')}></InputMask>
                                <div className="invalid-feedback">Kode OTP wajib diisi.</div>
                            </div>
                            <div className="login-buttons m-b-5">
                                <button type="submit" className="btn btn-blue btn-block btn-lg" disabled={submitLoading}>
                                    {(submitLoading) ?
                                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        :
                                        'Simpan'
                                    }
                                </button>
                            </div>
                            <div className="login-buttons">
                                <Link to='/login' className="btn btn-success btn-block btn-lg" disabled={submitLoading}>
                                    Kembali ke Halaman Login
                                </Link>
                            </div>
                            <hr />
                            <p className="text-center text-grey-darker">
                                {COPYRIGHT}
                            </p>
                        </form>
					</div>
				</div>
			</div>
		)
	}
}

export default withNotification(withRouter(ChangePassword));